<div class="container align-items-center" *ngIf="estatus === 'exito'">
  <div class="text-center">
    <i class="bi bi-check-circle-fill success-icon"></i>
    <h2 class="mt-4 text-success">¡Registro exitoso!</h2>
    <p class="lead">Tu cuenta ha sido creada correctamente. Pronto recibirás más información por correo electrónico.</p>
    <a routerLink="/" class="btn btn-success mt-3">Ir al inicio</a>
  </div>
</div>

<div class="container align-items-center" *ngIf="estatus == 'El correo ya existe en el TDS'">
  <div class="text-center">
    <i class="bi bi-x-circle-fill error-icon"></i>
    <h2 class="mt-4 text-danger">Cuenta ya registrada</h2>
    <p class="lead">Hemos detectado que ya tienes una cuenta asociada a este correo electrónico.</p>
    <p class="text-muted">Por favor, inicia sesión o actualiza tu contraseña si no la recuerdas.</p>
    <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mt-3">
      <a routerLink="/login" class="btn btn-primary">Iniciar sesión</a>
      <a routerLink="/actualizar-contrasena" class="btn btn-outline-secondary">¿Olvidaste tu contraseña?</a>
    </div>
  </div>
</div>